import * as React from 'react'
import { Button, Popover, PopoverSurface, PopoverTrigger, Text } from '@fluentui/react-components'
import { NormalizedError } from '../../reducers/errorReducer'
import { bundleIcon, InfoFilled, InfoRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'

const InfoIcon = bundleIcon(InfoFilled, InfoRegular)
export default function ErrorPopover(props: {
    error?: Pick<NormalizedError, 'message' | 'trace'>
    styles: Record<'button' | 'details' | 'moreInfo', string>
}) {
    const { t: translate } = useTranslation()

    return (
        <>
            {props.error?.message && (
                <div className={props.styles.button}>
                    <Popover withArrow>
                        <PopoverTrigger disableButtonEnhancement>
                            <Button icon={<InfoIcon />} appearance="subtle">
                                {translate('toast.error.open')}
                            </Button>
                        </PopoverTrigger>
                        <PopoverSurface className={props.styles.moreInfo}>
                            <Text size={200}>{translate('toast.error.label')}</Text>
                            <Text className={props.styles.details}>{props.error.message}</Text>
                            {props.error.trace && <Text size={200}>Details</Text>}
                            {props.error.trace && <Text className={props.styles.details}>{props.error.trace}</Text>}
                        </PopoverSurface>
                    </Popover>
                </div>
            )}
        </>
    )
}
